import { useEffect, useRef } from 'react';
import { consumer } from '../../../helpers/consumer.js';

export default function useMatchRegistryChannel(datagridId, setComparisonState) {
  const subscriptionRef = useRef(null);

  useEffect(() => {
    if (!datagridId) return;

    subscriptionRef.current = consumer.subscriptions.create(
      { channel: 'DatagridMatchRegistryChannel', datagrid_id: datagridId },
      {
        received: (data) => {
          if (typeof data.progress === 'number') {
            setComparisonState(data);
          }
        },
      }
    );

    return () => {
      subscriptionRef.current?.unsubscribe();
      subscriptionRef.current = null;
    };
  }, [datagridId]);

  return subscriptionRef;
}